import router from "./router";

export default router;
export * from "./routes";
